import { render, staticRenderFns } from "./ShoppingCartEmpty.vue?vue&type=template&id=2104a5e9&scoped=true&"
import script from "./ShoppingCartEmpty.vue?vue&type=script&lang=js&"
export * from "./ShoppingCartEmpty.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingCartEmpty.vue?vue&type=style&index=0&id=2104a5e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2104a5e9",
  null
  
)

export default component.exports